import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { useQueryInfo } from '../hooks/store';
import {
    useTeamId,
    useIsClubPage,
} from '../hooks/config';
import { useImageUtils } from '../hooks';
import { SEARCH_ROUTE, QUERY_PARAMS } from '../utils/constants';

import { CategoryRowV1 as Component } from '../components/CategoryRow';

const CategoryRow = forwardRef(({
    skip,
    ssr,
    properties,
    rank,
    className,
}, ref) => {

    const teamId = useTeamId();
    const isClubPage = useIsClubPage();
    const { formatTemplateUrl } = useImageUtils();

    const {
        title,
        categories = [],
    } = properties;

    const queries = useMemo(() => categories.map((category) => {

        let {
            query,
            queryClubFilter,
        } = category;

        if (isClubPage && queryClubFilter) {

            query = `${queryClubFilter} == [${teamId}] AND ${query}`;

        }
        return query;

    }), [
        categories,
        isClubPage,
        teamId,
    ]);

    const { data: queryInfoData, loading } = useQueryInfo(queries, {
        skip,
        ssr,
        includeCount: true,
    });

    const data = useMemo(() => categories.map(({ imageStoragePath, title }, index) => ({
        imageTemplateUrl: formatTemplateUrl(imageStoragePath),
        count: queryInfoData?.[index]?.count,
        title,
        link: `${SEARCH_ROUTE}?${QUERY_PARAMS.query}=${queries[index]}`,
    })), [
        queryInfoData,
        categories,
        queries,
        formatTemplateUrl,
    ]);

    return (
        <Component
            ref={ref}
            title={title}
            categories={data}
            loading={skip || loading}
            rank={rank}
            className={className}
        />
    );

});

CategoryRow.propTypes = {
    rank: PropTypes.number.isRequired,
    skip: PropTypes.bool,
    ssr: PropTypes.bool,
    properties: PropTypes.shape({
        title: PropTypes.string,
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                query: PropTypes.string,
                queryClubFilter: PropTypes.string,
                imageStoragePath: PropTypes.string,
                title: PropTypes.string,
            })
        ),
    }),
};

CategoryRow.defaultProps = {
    skip: false,
    ssr: true,
    properties: {},
};

export default CategoryRow;
